function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 16,
  fill: "#14315c",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 14.344,
  fill: "#14315c",
  fillOpacity: 1,
  transform: "rotate(45 64 64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 12.531,
  fill: "#14315c",
  fillOpacity: 1,
  transform: "rotate(90 64 64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 10.75,
  fill: "#14315c",
  fillOpacity: 1,
  transform: "rotate(135 64 64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 10.063,
  fill: "#14315c",
  fillOpacity: 1,
  transform: "rotate(180 64 64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 8.063,
  fill: "#14315c",
  fillOpacity: 1,
  transform: "rotate(225 64 64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 6.438,
  fill: "#14315c",
  fillOpacity: 1,
  transform: "rotate(270 64 64)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 64,
  r: 5.375,
  fill: "#14315c",
  fillOpacity: 1,
  transform: "rotate(315 64 64)"
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  values: "0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64",
  calcMode: "discrete",
  dur: "960ms",
  repeatCount: "indefinite"
}));

var SvgLoader = function SvgLoader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader.1ede6145.svg";
export { ForwardRef as ReactComponent };